<template>
  <div class="v-about">
        kkk 
  </div>
</template>
<script>
  //import GIF from 'gif.js'
  var height = $(window).height(), noticed;
  export default {
    data() {
      return {
        gif: null,
      }
    },
    mounted() {
      // let that = this;
      // $('body').on('touchstart', ()=>{
      //   this.autoPlay();
      // });
      //this.renderGif();

      this.more();
    },
    methods: {
      more(){
          let maxTop = 0;
          $('.more').click(function () {
          if (maxTop === 0) {//dom渲染延迟,  这里设置maxTop值
            maxTop = Math.round($('.video-wrapper').height());
          }

          let top = 0;
          let inter = setInterval(() => {
            top += 50;
            if (top >= maxTop) {
              top = maxTop;
              clearInterval(inter);
            }
            $(document).scrollTop(top)
          }, 10)
        });
      },

      renderGif(){
        console.log('home',  GIF);
        this.gif = new GIF({
          workers: 2,
          quality: 10
        });
        console.log('home',  this.gif);
        // add an image element
        //this.gif.addFrame(imageElement);
        this.gif.on('finished', function(blob) {
          window.open(URL.createObjectURL(blob));
        });

        this.gif.render();
      },

      //如果没有自动播放, 则手动播放
      autoPlay() {
        var inter = setInterval(() => {
          let video = $('.video')[0];
          if (video && video.paused) {
            try {
              video.play();
            } catch (e) {
            }
          } else {
            clearInterval(inter); //直至成功, 清除定时器
          }
        }, 200)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .v-about {
    width: 100%;
    margin-top:1rem;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/view/aboutCompany.vue